import { Card, Avatar, Row, Col, Button, Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Space } from "antd";
import { Tooltip } from "antd";
import { Typography, Image } from "antd";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

import styles from "./Team.module.scss";
import { Title } from "../Title/Title";
import { Fade, Slide } from "react-awesome-reveal";
import Member1 from "@assets/KPMG/Team/1.png";
import Member2 from "@assets/KPMG/Team/2.png";
import Member3 from "@assets/KPMG/Team/3.png";
import Member4 from "@assets/KPMG/Team/4.png";
import Member5 from "@assets/KPMG/Team/5.png";

const { Meta } = Card;

interface DataItem {
  id: number;
  name: string;
  department: string;
  description: string;
  location: string;
  avatar: string;
}
const dummyData: DataItem[] = [
  {
    id: 1,
    name: "Sharad Somani",
    department: "Partner, Infrastructure Advisory",
    description:
      "Sharad has more than 25 years’ experience in infrastructure sectors, covering transport; broadband; urban/industrial infrastructure; and power (renewable energy, water, waste to energy) and liquefied natural gas.",
    location: "KMPG Singapore",
    avatar: Member1,
  },
  {
    id: 2,
    name: "Deven Chhaya",
    department: "Partner, Infrastructure Advisory",
    location: "KMPG Singapore",
    description:
      "Deven leads infratech advisory services armed with more than 25 years’ industry experience in ports, smart cities and energy and utilities, he has led numerous transformation efforts in energy transition, technology and citizen services.",
    avatar: Member3,
  },
  {
    id: 3,
    name: "Wen Bin Lim",
    department: "Director, Infrastructure Advisory",
    description:
      "Wen Bin brings over 15 years of Singapore energy market experience and has advised on electricity market design, energy market reform and policy and regulation internationally",
    location: "KMPG Singapore",
    avatar: Member2,
  },
  {
    id: 4,
    name: "Abhishek Dubey",
    department: "Associate Director, Infrastructure Advisory",
    location: "KMPG Singapore",
    description:
      "Has more than 14 years of consulting experience in digital transformation, digital strategy, IT strategy, and related projects. He has worked extensively with public sector clients driving programs and projects on Digital Strategy, Data Strategy, Innovation, and Technology implementation.",
    avatar: Member5,
  },
];
export const TeamCards = () => {
  const cardsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(dummyData.length / cardsPerPage);
  const [visibleData, setVisibleData] = useState<DataItem[]>([]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentData = dummyData.slice(startIndex, endIndex);
    setVisibleData(currentData);
  }, [currentPage]);

  return (
    <>
      <Fade direction="left" triggerOnce>
        <Row className="meet-our-team" style={{ background: "#F9FBFD" }}>
          <Col md={2}></Col>
          <Col md={20} style={{ marginTop: styles.whitespace5 }}>
            <Title title="MEET OUR TEAM" variant={2} />
            <Swiper
              style={{ padding: 50 }}
              // install Swiper modules
              modules={[Navigation, Pagination, A11y, Autoplay]}
              spaceBetween={50}
              slidesPerView={3}
              navigation={true}
              autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
              // loop={true}
              // loopedSlides={2}
              grabCursor={true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
            >
              {visibleData.map((data: any, index: number) => (
                <SwiperSlide style={{ height: "auto" }} key={index}>
                  <Card
                    style={{
                      display: "flex",
                      alignItems: "center",
                      boxShadow: "0px 0px 25px rgba(245, 241, 241, 0.1)",
                      // justifyContent: "center",
                      flexDirection: "column",
                      textAlign: "center",
                      minWidth: "280px",
                      height: "98%",
                    }}
                  >
                    <Space direction="vertical" size="middle">
                      {/* <Tooltip title="Social Media">
                        </Tooltip> */}
                      <Avatar size={140} src={data.avatar} />

                      <Card.Meta
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        title={
                          <Typography.Title
                            level={5}
                            style={{ marginBottom: 0 }}
                          >
                            {data.name}
                          </Typography.Title>
                        }
                        description={
                          <div>
                            <div style={{ marginBottom: 10 }}>
                              <Typography.Text
                                className="textSmall"
                                style={{ color: "#29256E" }}
                              >
                                {data.department}
                              </Typography.Text>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                              <Typography.Text style={{ fontSize: 13 }}>
                                {data.description}
                              </Typography.Text>
                            </div>
                          </div>
                        }
                      />
                    </Space>
                    <Row style={{ justifyContent: "center" }}>
                      <Col>
                        <Icon
                          icon={"material-symbols:location-on-outline"}
                        ></Icon>
                      </Col>
                      <Col>
                        <p
                          className="textSmall"
                          style={{ color: "#49926F", marginBottom: 0 }}
                        >
                          {data.location}
                        </p>
                      </Col>
                    </Row>
                  </Card>
                  {/* </Col> */}
                </SwiperSlide>
              ))}
            </Swiper>
            {/* </Row> */}
          </Col>
          <Col md={2}></Col>
        </Row>
      </Fade>
    </>
  );
};
